import { cilSync } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import { CCard, CCardBody, CCardHeader } from '@coreui/react';
import * as React from 'react';
import { IRefreshWidgetSignal } from '../abstraction';
import { Widget } from '../views/Widget';

export interface IWidget {
	longText: string;
	target: string;
}

interface IProps {
	item: IWidget;
	refreshHandler?: IRefreshWidgetSignal;
}

interface IState {
	refreshToken: number;
}

// Représente une vignette (affichée sur la page d'accueil générale)
//
export class KWidget extends React.Component<IProps, IState> {
	public constructor(props: any) {
		super(props);
		this.state = { refreshToken: Math.random(), }
	}

	// Click sur icôen déclenchant le rafraîchissement du widget
	onClickIconRefresh = (target: string) => {
		if (this.props.refreshHandler) {
			this.props.refreshHandler.SendRefresh(target);
		}
	}

	// Rendu principal
	render() {
		let item = this.props.item;
		return (
			<CCard>
				<CCardHeader>
					<div>
						{item.longText}
					</div>
					<div className="RefreshIcon">
						<CIcon content={cilSync} onClick={() => this.onClickIconRefresh(item.target)} />
					</div>
				</CCardHeader>
				<CCardBody>
					<Widget fnct={item.target} refreshToken={this.state.refreshToken} />
				</CCardBody>
			</CCard>
		);
	}
}
